//@ts-nocheck
import { useToast } from "@chakra-ui/react";
import Pluralize from "pluralize";
import React from "react";
import { FormStepType, IRootStore } from "../../stores";
import { STEPS } from "../../stores/rootStore";
import educationHistoryData from "../../tutor-revamp/formData/educationHistory.json";
import locationInfoData from "../../tutor-revamp/formData/locationInfo.json";
import personalInfoData from "../../tutor-revamp/formData/personalInfo.json";
import workHistoryData from "../../tutor-revamp/formData/workHistory.json";
import {
  arrayToString,
  capFirstLetter,
  getCountryDialCode,
  scrollToId,
} from "../../utils/functions";
import guarantorInfoData from "../../tutor-revamp/formData/guarantorInfo.json";

export function buildFormWrapperProps(store: IRootStore, step: string): any {
  let lessonType: any = store.locationInfo.lessonType;
  const options = {
    [STEPS.PERSONAL_INFO]: {
      formHeader: personalInfoData.formTitle.name,
      formSummary: [
        store.personalInfo.firstName + " " + store.personalInfo.lastName,
        `DOB: ${store.personalInfo.dateOfBirth}`,
        store.personalInfo.email,
        store.personalInfo.phone,
      ],
      formOptionsData: {
        sources: store.educationWorkHistory.data.sources,
        languages: store.educationWorkHistory.data.languages,
      },
      countries: store.locationInfo.countries.map((country) => country.name),
      lockedDescription: personalInfoData.formTitle.subHeader,
      store: store.personalInfo,
      minCode: `+${getCountryDialCode(store.locationInfo.country)}`.length,
    },
    [STEPS.LOCATION_INFO]: {
      store: store.locationInfo,
      formHeader: locationInfoData.formTitle.name,
      lockedDescription: "Enter your location",
      previousStep: STEPS.PERSONAL_INFO,
      formSummary: [
        store.locationInfo.state + ", " + store.locationInfo.country,
        store.locationInfo.region,
        `${arrayToString(lessonType.map((elem) => capFirstLetter(elem)))}`,
        Pluralize(
          "exempted area",
          store.locationInfo.exemptedAreas.length,
          true
        ),
      ],
    },
    [STEPS.EDUCATION_HISTORY]: {
      store: store.educationWorkHistory,
      educationData: store.educationWorkHistory.data,
      countries: store.locationInfo.countries,
      formHeader: educationHistoryData.formTitle.name,
      formsetDescription: educationHistoryData.formTitle.subHeader,
      displayType: "complex",
      lockedDescription: educationHistoryData.formTitle.subHeader,
      buttonText: educationHistoryData.buttonText.saveAndContinue,
      textData: educationHistoryData,
      completed: store.educationWorkHistory.educationCompleted,
      shouldDisplayButton:
        store.currentEditableForm === STEPS.EDUCATION_HISTORY &&
        store.educationWorkHistory.educationCompleted,
    },
    [STEPS.WORK_HISTORY]: {
      store: store.educationWorkHistory,
      formHeader: workHistoryData.formTitle.header,
      formsetDescription: workHistoryData.formTitle.subHeader,
      displayType: "complex",
      shouldDisplayButton: store.currentEditableForm === STEPS.WORK_HISTORY,
      lockedDescription: workHistoryData.formTitle.subHeader,
      buttonText: workHistoryData.buttonText.saveAndContinue,
      textData: workHistoryData,
      completed: store.educationWorkHistory.workCompleted,
    },
    [STEPS.SCHEDULE_INFO]: {
      store: store.schedule,
      formHeader: "Your availability",
      previousStep: STEPS.SUBJECT_SELECTION,
      lockedDescription: "Select your teaching schedule",
      formSummary: [
        `Available days: ${
          Object.values(store.schedule.availability).filter(
            (elem) => elem.length
          ).length
        }`,
        `Max. days: ${store.schedule.maxDays}`,
        `Max. hours: ${store.schedule.maxHours}`,
        `Max. students: ${store.schedule.maxStudents}`,
      ],
    },
    [STEPS.TEACHING_PROFILE]: {
      store: store.teachingProfile,
      formHeader: "Special needs",
      previousStep: STEPS.SCHEDULE_INFO,
      completed: [
        STEPS.PERSONAL_INFO,
        STEPS.LOCATION_INFO,
        STEPS.EDUCATION_HISTORY,
        STEPS.WORK_HISTORY,
        STEPS.SUBJECT_SELECTION,
        STEPS.SCHEDULE_INFO,
      ].includes(store.currentEditableForm)
        ? false
        : store.teachingProfile.completed,
      lockedDescription:
        "If you are specially trained to teach learners with disabilities, or if you have a disability, please let us know.",
      label: STEPS.TEACHING_PROFILE,
      formSummary: [
        ...store.teachingProfile.specialNeeds,
        ...store.teachingProfile.tutorDisabilities,
      ],
    },
    [STEPS.GUARANTOR_INFO]: {
      previousStep: STEPS.VERIFY_EMAIL,
      store: store.educationWorkHistory,
      formHeader: guarantorInfoData.formTitle.header,
      formsetDescription: guarantorInfoData.formTitle.subHeader,
      displayType: "complex",
      shouldDisplayButton:
        store.currentEditableForm === STEPS.GUARANTOR_INFO ||
        store.educationWorkHistory.guarantorsCompleted,
      lockedDescription: guarantorInfoData.formTitle.subHeader,
      buttonText: guarantorInfoData.buttonText.saveAndContinue,
      textData: guarantorInfoData,
      completed: store.educationWorkHistory.guarantorsCompleted,
    },
    [STEPS.PAYMENT_INFO]: {
      previousStep: STEPS.GUARANTOR_INFO,
      store: store.paymentInfo,
      supportedCountry: store.supportedCountryData,
      formHeader: "Payment information",
      lockedDescription: "Enter your bank details to get paid",
      formSummary: [
        store.paymentInfo.bankName,
        store.paymentInfo.accountName,
        store.paymentInfo.accountNumber,
      ],
    },
    [STEPS.NEW_DEVELOPMENT]: {
      store: store.others,
      previousStep: STEPS.PAYMENT_INFO,
      formHeader: "Tutoring process",
      lockedDescription: "Understand our teaching and learning process",
      formSummary: ["I've read the tutoring process"],
    },
    [STEPS.AGREEMENT_INFO]: {
      previousStep: STEPS.NEW_DEVELOPMENT,
      store: store.agreement,
      formHeader: "Tutoring agreements",
      lockedDescription: "Agree to our tutoring policy and agreements",
      formSummary: [
        `Contract with Tuteria: ${
          store.agreement.paymentDate === true ? "Agreed" : "Not Agreed"
        }`,
        `Obligations to Tuteria: ${
          store.agreement.taxCompliance === true ? "Agreed" : "Not Agreed"
        }`,
        `Payment policies: ${
          store.agreement.lessonPercent === true ? "Agreed" : "Not Agreed"
        }`,
        `Dismissal conditions: ${
          store.agreement.contractAgreement === true ? "Agreed" : "Not Agreed"
        }`,
      ],
    },
    // [STEPS.GUARANTOR_INFO]: {
    //   previousStep: STEPS.VERIFY_EMAIL,
    //   store: store.educationWorkHistory,
    //   formHeader: guarantorInfoData.formTitle.header,
    //   description: guarantorInfoData.formTitle.subHeader,
    //   displayType: "complex",
    //   hideStep: true,
    //   shouldDisplayButton: false,
    //   lockedDescription: guarantorInfoData.formTitle.subHeader,
    //   buttonText: guarantorInfoData.buttonText.saveAndContinue,
    //   textData: guarantorInfoData,
    //   completed: store.educationWorkHistory.guarantorsCompleted,
    // },
    [STEPS.VERIFY_EMAIL]: {
      store,
      completed: store.emailVerified,
      formHeader: "Email Verification",
      lockedDescription: "Verify your email",
    },
  };
  return {
    ...options[step],
    label: step,
    loading: store.loading,
  };
}
const stepsArray: any = [
  { key: STEPS.PERSONAL_INFO, name: "Personal Information", completed: false },
  {
    key: STEPS.EDUCATION_HISTORY,
    name: "Education History",
    completed: false,
  },
  { key: STEPS.WORK_HISTORY, name: "Work History", completed: false },
  { key: STEPS.LOCATION_INFO, name: "Location Information", completed: false },
  { key: STEPS.SCHEDULE_INFO, name: "Schedule Information", completed: false },
  { key: STEPS.TEACHING_PROFILE, name: "Teaching Profile", completed: false },
  {
    key: STEPS.GUARANTOR_INFO,
    name: "Guarantor Information",
    completed: false,
  },
  {
    key: STEPS.NEW_DEVELOPMENT,
    name: "New Development Information",
    completed: false,
  },
  {
    key: STEPS.AGREEMENT_INFO,
    name: "Agreements Information",
    completed: false,
  },
];

export const useFormIndexStep = (
  store: IRootStore,
  _stepArray: any[],
  currentStep?: string
) => {
  const toast = useToast();
  const [formIndex, setFormIndex] = React.useState(1);
  const [steps, setSteps] = React.useState<any[]>(_stepArray);
  const [activeStep, setActiveStep] = React.useState(
    currentStep || store.currentEditableForm
  );
  const [completedForm, setCompletedForm] = React.useState(false);
  React.useEffect(() => {
    let id = activeStep;
    scrollToId(id);
    setActiveStep(id);
  }, [store.currentEditableForm, activeStep]);
  const handleFormSubmit = (
    id: FormStepType | string,
    presentStep: FormStepType | string,
    complete = false
  ) => {
    setFormIndex((index) => index + 1);
    setActiveStep(id);
    if (!complete) {
      store.setEditableForm(id);
      setSteps(
        [...steps].map((object) => {
          if (object.key === presentStep) {
            return {
              ...object,
              completed: true,
            };
          } else return object;
        })
      );
    }
  };
  function onError() {
    toast({
      title: `An error occured.`,
      status: "error",
      duration: 5000,
      isClosable: true,
      position: "top",
    });
  }
  return {
    formIndex,
    handleFormSubmit,
    steps,
    activeStep,
    completedForm,
    setCompletedForm,
    onError,
  };
};

export const useTutorApplicationFlow = (
  store: IRootStore,
  currentStep?: string
) => {
  const {
    onError,
    activeStep,
    completedForm,
    formIndex,
    steps,
    setCompletedForm,
    handleFormSubmit,
  } = useFormIndexStep(store, stepsArray, currentStep);
  async function onSubmitSection(formData: any, label = "") {
    let options = {
      [STEPS.PERSONAL_INFO]: STEPS.EDUCATION_HISTORY,
      // [STEPS.LOCATION_INFO]: STEPS.PAYMENT_INFO,
      [STEPS.EDUCATION_HISTORY]: STEPS.WORK_HISTORY,
      [STEPS.WORK_HISTORY]: STEPS.SUBJECT_SELECTION,
      [STEPS.LOCATION_INFO]: STEPS.SCHEDULE_INFO,
      // [STEPS.SUBJECT_SELECTION]: STEPS.SCHEDULE_INFO,
      [STEPS.SCHEDULE_INFO]: STEPS.TEACHING_PROFILE,
      [STEPS.TEACHING_PROFILE]: STEPS.PAYMENT_INFO,
      [STEPS.PAYMENT_INFO]: STEPS.GUARANTOR_INFO,
      [STEPS.GUARANTOR_INFO]: STEPS.NEW_DEVELOPMENT,
      [STEPS.NEW_DEVELOPMENT]: STEPS.AGREEMENT_INFO,
      [STEPS.AGREEMENT_INFO]: STEPS.VERIFY_EMAIL,
    };
    let _activeStep =
      label || (store.isEditAction ? store.editIndex : activeStep);
    let newStep = options[_activeStep];
    // attempt validation of the different form steps before attempting submission.
    // try {
    //   await store.validateFormStep(formData, _activeStep);
    // } catch (error) {
    //   // supposed to raise form error with the formErrors property.
    //   throw error;
    // }
    try {
      await store.onFormSubmit(formData, _activeStep, newStep);
      if (newStep === STEPS.VERIFICATION) {
        setCompletedForm(true);
      }
      if (store.isEditAction || label) {
        // this ensures that the current step does not change on edit.
        store.setEditAction(false);
      } else {
        handleFormSubmit(newStep, activeStep);
      }
    } catch (error) {
      onError();
      throw error;
    }
  }
  async function onValidateStep(formData, step) {
    return await store.validateFormStep(formData, step);
  }

  function getFormWrapperProps(step: any): any {
    let result = buildFormWrapperProps(store, step);
    const formOrder = [
      STEPS.PERSONAL_INFO,
      STEPS.EDUCATION_HISTORY,
      STEPS.WORK_HISTORY,
      STEPS.LOCATION_INFO,
      STEPS.SCHEDULE_INFO,
      STEPS.TEACHING_PROFILE,
      STEPS.PAYMENT_INFO,
      STEPS.GUARANTOR_INFO,
      STEPS.NEW_DEVELOPMENT,
      STEPS.AGREEMENT_INFO,
      STEPS.VERIFY_EMAIL,
    ];
    let stepIndex = formOrder.indexOf(step);
    let currentStepIndex = formOrder.indexOf(activeStep);
    return {
      ...result,
      onSubmit: onSubmitSection,
      currentStep: activeStep,
      canEdit: currentStepIndex > stepIndex || !formOrder.includes(activeStep),
      async onValidateStep(v: any) {
        return await onValidateStep(v, step);
      },
    };
  }
  return {
    activeStep,
    steps,
    getFormWrapperProps,
    completedForm,
    formIndex,
    handleFormSubmit,
  };
};
